import React, { useEffect, useState } from 'react'
import './logs-table-container.styles.scss';

//components
import Pagination from '../../../../../components/pagination/Pagination';
import { PulseLoader } from 'react-spinners';
import LogsTableHeader from '../logs-table-header/LogsTableHeader';
import LogRow from '../log-row/LogRow';
import AdminDownloadConfirmPopup from '../../admin-download-confirm-popup/admin-download-confirm-popup';
import {TriyoButton, SecondaryButton } from '../../../../../components/TriyoButton';

//redux
import {connect} from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectUser } from '../../../../../redux/user/user-selector';
import {selectSearchLogsQuery, selectLogs, selectNumLogs, selectIsFetchingLogs, selectSelectedLogs } from '../../../../../redux/admin/admin-selector';
import { fetchLogs } from '../../../../../redux/admin/admin-actions';

const LogsTableContainer = ({user:{privileges}, data, fetchData, searchQuery, numEntries, loading}) => {

    const [showDownloadsPanel, setShowDownloadsPanel] = useState(false);
    const [headerKey, setHeaderKey] = useState(false);
    const containRecords = data?.length > 0;
    const canDownload = privileges.Group.Add && containRecords;
    
    useEffect(() => {

        refreshPage();

    }, []);

     /////// PAGINATION and SORTING

    const refreshPage = () => {

        setHeaderKey(!headerKey); //Will trigger component remount to reset everything in header to default state
        fetchData({ pageSize: 10, pageNumber: 1, sortDesc: false, sortBy: "name", filters: [] });

        //fetchAllUsers();  //used only to get total user count. Needs to be changed asap!!
    }

    const changeData = (filters = searchQuery.filters, sortBy = searchQuery.sortBy, sortDesc = searchQuery.sortDesc) => {
        fetchData({...searchQuery, filters: filters, sortBy: sortBy, sortDesc:sortDesc});
    }

    const nextPage = () => {
        const newSearchQuery = {...searchQuery, pageNumber: searchQuery.pageNumber + 1};
        fetchData(newSearchQuery);
    }

    const prevPage = () => {
        const newSearchQuery = {...searchQuery, pageNumber: searchQuery.pageNumber - 1};
        searchQuery.pageNumber >= 1 && fetchData(newSearchQuery);
    }

    const rowChange = (numRows) => {
        fetchData({...searchQuery, pageSize: numRows, pageNumber: 1 });
    }

    /*
    //Called on sort element
    const sortLogs = (sortType = "name", sortDesc = false) => {

        if(rowsToDisplay.length <= 0 || !rowsToDisplay[0].log.hasOwnProperty(sortType)){
            return;
        }

        let sortedArray = JSON.parse(JSON.stringify(rowsToDisplay)); //Easy way to do deepcopy so we can do inplace sort without mutating anything accidentally

        sortedArray.sort( (element1, element2) => {
            let returnValue = 0;
            let object1 = element1.log[sortType];
            let object2 = element2.log[sortType];

            if(sortType === "createdDate"){
                let date1 = new Date(object1);
                let date2 = new Date(object2);

                returnValue = date2-date1;
            } else if (typeof object1 === 'number') {
                returnValue = object2 - object1;
            } else {
                object1 === null ? object1 = "" : object1 = object1.toString();
                object2 === null ? object2 = "" : object2 = object2.toString();
                returnValue = object1.localeCompare(object2);
            }

            if (sortDesc) returnValue *= -1;
            return returnValue;
        })
        changeView(sortedArray);
        setRowsToDisplay(sortedArray);
    } */


    ////// RENDER ROWS FOR TABLE

    const renderRows = () => {

        const Rows = data && data.map(({log}) => {
            return <LogRow key={log.logActivityID} data={log} privileges={privileges}/>
         })
         return Rows;
     }



    return (
        <div className='admin-panel-table-container'>
            <div className='table-control-container'>
                <TriyoButton>                               
                    <SecondaryButton  
                      onClick={() => { setShowDownloadsPanel(true) }}
                      disabled={!canDownload}
                      text="Download Log Activity List"/>
                 </TriyoButton>
                <Pagination
                refresh={refreshPage}
                next={nextPage}
                prev={prevPage}
                rowChange={rowChange}
                numEntries={numEntries}
                query={searchQuery}/>
            </div>
            <div className='table-message-container'>
                Please note that only the most recent 1,000 records will be displayed or downloaded to avoid excess server load.
            </div>
            <AdminDownloadConfirmPopup
                show={showDownloadsPanel}
                onHide = {() => setShowDownloadsPanel(false)}
                type={'log-activity'}
                button={'Download'}
            />


            {data ?

                <div className='table-main'>
                    <table className="table-element">
                        <LogsTableHeader
                            key = {headerKey} //Easy way to restart component mounting to reset to default state
                            changeData = {changeData}
                            refreshPage = {refreshPage}
                        />
                        {
                            !loading ? (
                            <tbody>
                                {
                                    renderRows()
                                }
                            </tbody>
                            ) : (
                                <div className = 'pulse-loader'>
                                    <PulseLoader></PulseLoader>
                                </div>
                            )
                        }
                    </table>

                </div>
                :   <div className = 'pulse-loader'>
                        <PulseLoader></PulseLoader>
                    </div>
          }

        </div>
    )
}

const mapState = createStructuredSelector({
    user: selectUser,
    searchQuery: selectSearchLogsQuery,
    data: selectLogs,
    numEntries: selectNumLogs,
    loading: selectIsFetchingLogs,
    selectedRows: selectSelectedLogs
})

const mapDispatch = (dispatch) => ({
    fetchData: searchQuery => dispatch(fetchLogs(searchQuery)),
    // fetchAllUsers: () => dispatch(fetchAllUsers()),
})

export default connect(mapState, mapDispatch)(LogsTableContainer);
